module.exports = __webpack_public_path__ + "img/banner2-1@1x.0a8c0039.jpg";